import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import * as routerHelpers from "app/router/RouterHelpers";

/**
 * Component that handles protected routes - redirects to auth if not authorized
 */
export function ProtectedRoute({ children }) {
  const isAuthorized = useSelector((store) => !!store.auth.user);

  if (!isAuthorized) {
    return <Navigate to="/auth/login" replace />;
  }

  return children;
}

/**
 * Component that handles auth routes - redirects to last location if authorized
 */
export function AuthRoute({ children }) {
  const isAuthorized = useSelector((store) => !!store.auth.user);
  const hasMfaSetupFlow = useSelector((store) => Boolean(store.auth.mfaFlow?.setupToken));
  const userLastLocation = routerHelpers.getLastLocation();
  const { pathname } = useLocation();
  const isMfaSetupRoute = pathname === "/auth/two-factor-setup";
  const isInviteRoute = pathname.startsWith("/auth/invite/");

  if (isAuthorized && !(isInviteRoute || (isMfaSetupRoute && hasMfaSetupFlow))) {
    return <Navigate to={userLastLocation} replace />;
  }

  return children;
}
